var EHDI = EHDI || Object.create(null);

EHDI.GameStateEnum = {
  GAMEINITIALIZING: 0,
  GAMESTARTED: 1,
  GAMEPAUSED: 2,
  GAMERESUMED: 3,
  GAMEOVER: 4,
};

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.GameScene = function () {
    EHDI.Scene.call(this);
};

EHDI.scene.GameScene.prototype = Object.create(EHDI.Scene.prototype);

EHDI.scene.GameScene.prototype.screenWillAppear = function () {
  this.init();
};

EHDI.scene.GameScene.prototype.popUpWillAppear = function() {
  EHDI.GAME.soundManager.pauseBGM();
};

EHDI.scene.GameScene.prototype.popUpDidDisappear = function() {
  EHDI.GAME.soundManager.resumeBGM();
};

EHDI.scene.GameScene.prototype.screenDidAppear = function () {

  this.startGame();
  if(EHDI.GAME.saveData.isFirstTimePlay)
  {
    EHDI.GAME.saveData.isFirstTimePlay = false;
    EHDI.GAME.storageManager.setLocalInfo( EHDI.GAME.id, EHDI.GAME.saveData );
    /* EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
        console.log("data saved.");
    }); */
    EHDI.GAME.pauseButton.isPaused = true;
    EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});

    this._handler_pauseGame();
  }
}

EHDI.scene.GameScene.prototype.screenDidDisappear = function () {
  this.destroy();
}

EHDI.scene.GameScene.prototype.init = function () {
    this.initProps();
    this.initUtils();
    this.initGraphics();
    this.initListeners();
  };

EHDI.scene.GameScene.prototype.initProps = function () {
  this._gameState;
  this._deltaTotal = 0;
  this._deltaLimit = 25;
  this._currentTime = 0;
  this._totalTime = 120;
  this._gameWidth = 1024;
  this._gameHeight = 600;

  this._level = 1;
  this._animalSpawnDelay = 2500;
  this._animalCurrentSpawnDelay = 0;
  this._snakeSpawnDelay = 3000;
  this._snakeCurrentSpawnDelay = 0;
  this._despawnDelay = 4000;
  this._score = 20;
  this._scoreMultiplier = 0;

  this._prevState;
  this._gameState = EHDI.GameStateEnum.GAMEINITIALIZING;

  this._idleSpawnData = [new EHDI.aka.Point(217, 181),
                      new EHDI.aka.Point(365, 361),
                      new EHDI.aka.Point(480, 176),
                      new EHDI.aka.Point(633, 345),
                      new EHDI.aka.Point(745, 156)];

  this._activeSpawnData = [];
};

EHDI.scene.GameScene.prototype.initUtils = function () {
  this._gameTimer;
  this._animalSpawnTimer;
  this._snakeSpawnTimer;
  this._scoreMultiplierTimer;

  if (this._gameTimer == null)
    this._gameTimer = new EHDI.util.Time();

  if (this._animalSpawnTimer == null)
    this._animalSpawnTimer = new EHDI.util.Time();

  if (this._snakeSpawnTimer == null)
    this._snakeSpawnTimer = new EHDI.util.Time();

  if (this._scoreMultiplierTimer == null)
    this._scoreMultiplierTimer = new EHDI.util.Time();
};

EHDI.scene.GameScene.prototype.initGraphics = function () {
  this._hudContainer;
  this._backgroundContainer;
  this._gameContainer;
  this._foregroundContainer;

  this._hudPauseButton;
  this._scoreContainer;
  this._hudTimer;

  this._backgroundTexture;
  this._background;
  this._foregroundTexture;
  this._foreground;

  this._leafAnimations = [];
  this._tapAnimations = [];

  this._animals = [];
  this._warnings = [];

  this._glows = [];

  if (this._backgroundContainer == null) {
    this._backgroundContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._backgroundContainer);
  }

  if (this._backgroundTexture == null) {
    this._backgroundTexture = EHDI.Assets.images['bg_serpent'];
  }

  if (this._background == null) {
    this._background = new EHDI.aka.Sprite(this._backgroundTexture);

    this._backgroundContainer.addChild(this._background);
  }

  if (this._gameContainer == null) {
    this._gameContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._gameContainer);
  }

  if (this._foregroundContainer == null) {
    this._foregroundContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._foregroundContainer);
  }

  if (this._foregroundTexture == null) {
    this._foregroundTexture = EHDI.Assets.images['serpent_tree'];
  }

  if (this._foreground == null) {
    this._foreground = new EHDI.aka.Sprite(this._foregroundTexture);

    this._foregroundContainer.addChild(this._foreground);
  }

  if (this._hudContainer == null) {
    this._hudContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._hudContainer);
  }

  if (this._scoreContainer == null) {
    this._scoreContainer = new EHDI.components.ScoreManager(this._hudContainer);
    this._scoreContainer.setXY(10,10);
  }

  if (this._hudTimer == null) {
    this._hudTimer = new EHDI.components.Timer();

    this._hudTimer.x = 290;
    this._hudTimer.y = 12;

    this._hudContainer.addChild(this._hudTimer);
  }

  if (this._hudPauseButton == null) {
    this._hudPauseButton = new EHDI.components.pauseButton();

    this._hudContainer.addChild(this._hudPauseButton);
  }

  this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
      this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.95, EHDI.GAME.sceneManager.getStageHeight() * 0.075);
      this.closeBtn.setOnClickFunction(function(){
        callFlexFunction()
      });
      this._hudContainer.addChild(this.closeBtn);
};

EHDI.scene.GameScene.prototype.destroyGraphics = function () {
  if (this._leafAnimations.length > 0) {
    while (this._leafAnimations.length > 0) {
      var leaf = this._leafAnimations.pop();

      this._foregroundContainer.removeChild(leaf.getDisplay());

      EHDI.GetGlobalPool().leafPool.return(leaf);
    }
  }

  if (this._tapAnimations.length > 0) {
    while (this._tapAnimations.length > 0) {
      var tap = this._tapAnimations.pop();
      this._foregroundContainer.removeChild(tap.getDisplay());

      EHDI.GetGlobalPool()._tapAnimations.return(tap);

      tap = null;
    }
  }

  if(this._animals != null)
  {
    if (this._animals.length > 0) {
      while (this._animals.length > 0) {
        var animal = this._animals.pop();
        this._gameContainer.removeChild(animal);
  
        animal.removeListener('ANIMAL_TAPPED', this._animapTappedWithBind);
        animal.removeListener('REMOVE_WARNING', this._animapRemoveWarningWithBind);
        animal.removeListener('SHOW_WARNING', this._animapShowWarningWithBind);
  
        // EHDI.GetGlobalPool().animalPool.return(animal);
  
        animal.destroy();
  
        animal = null;
      }
      this._animals= null;
    }
  }
  

  if(this._glows != null)
  {
    if (this._glows.length > 0) {
      while (this._glows.length > 0) {
        var glow = this._glows.pop();
  
        this._hudContainer.removeChild(glow);
  
        glow.destroy();
        // EHDI.GetGlobalPool().glowPool.return(glow);
        delete glow;
      }
    }
    this._glows = null;
  }
  

  if (this._warnings.length > 0) {
    while (this._warnings.length > 0) {
      var warning = this._warnings.pop();

      this._hudContainer.removeChild(warning);

      EHDI.GetGlobalPool().warningPool.return(warning);
    }
  }

  if (this._hudPauseButton != null) {
    this._hudContainer.removeChild(this._hudPauseButton);
    this._hudPauseButton.destroy();
    this._hudPauseButton = null;
  }
  if(this.closeBtn != null)
        {
            this._hudContainer.removeChild(this.closeBtn);
            this.closeBtn.destroy();
            this.closeBtn=null;
        }

  if (this._hudTimer != null) {
    this._hudContainer.removeChild(this._hudTimer);
    this._hudTimer.dispose();
    this._hudTimer = null;
  }

  if(this._background != null)
  {
    this._backgroundContainer.removeChild(this._background);
    this._background.destroy({children: true});
  }
  this._background = null;

  if(this._foreground != null)
  {
    this._foregroundContainer.removeChild(this._foreground);
    this._foreground.destroy({children: true});
  }
  this._foreground = null;

  if(this._foregroundContainer != null)
  {
    this.removeChild(this._foregroundContainer);
    this._foregroundContainer.destroy({children: true});
  }
  this._foregroundContainer = null;

  if(this._gameContainer != null) 
  {
    this.removeChild(this._gameContainer);
    this._gameContainer.destroy({children: true});
  }
  this._gameContainer = null;

  if (this._scoreContainer != null) {
    this._scoreContainer.dispose();
  }
  this._scoreContainer = null;

  if(this._hudContainer != null)
  {
    this.removeChild(this._hudContainer);
    this._hudContainer.destroy({children: true});
  }
  this._hudContainer = null;
};

EHDI.scene.GameScene.prototype.initListeners = function () {
  if (this.updateWithBind == null)
    this.updateWithBind = this.update.bind(this);

  EHDI.GAME.updateManager.addFrameListener(this.updateWithBind);

  this.onPauseWithBind = this._handler_pauseGame.bind(this);
  this.onResumeWithBind = this._handler_resumeGame.bind(this);

  this._hudPauseButton.on('PAUSE_GAME', this.onPauseWithBind);
  this._hudPauseButton.on('RESUME_GAME', this.onResumeWithBind);

  if (this._animalActivatedWithBind == null)
    this._animalActivatedWithBind = this._handler_animalActivated.bind(this);

  if (this._leafAnimationCompletedWithBind == null)
    this._leafAnimationCompletedWithBind = this._handler_leafAnimationCompleted.bind(this);

  if (this._tapAnimationCompletedWithBind == null)
    this._tapAnimationCompletedWithBind = this._handler_tapAnimationCompleted.bind(this);

  if (this._animapTappedWithBind == null)
    this._animapTappedWithBind = this._handler_animalTapped.bind(this);

  if (this._animapRemoveWarningWithBind == null)
    this._animapRemoveWarningWithBind = this._handler_animalRemoveWarning.bind(this);

  if (this._animapShowWarningWithBind == null)
    this._animapShowWarningWithBind = this._handler_animalSpawnWarning.bind(this);

  // if (EHDI.BrowserInfo.isMobileDevice) {
  //   this.interactive = true;
  //   this.onTouchWithBind = this._handler_onTouch.bind(this);
  //   this.on('pointerdown', this.onTouchWithBind);
  // } else {
  //   this.onKeyWithBind = this._handler_onKeyDown.bind(this);
  //   window.addEventListener('keydown', this.onKeyWithBind);
  // }
};

EHDI.scene.GameScene.prototype.destroyListeners = function () {
  if(this._hudPauseButton != null)
  {
    this._hudPauseButton.removeListener('PAUSE_GAME', this.onPauseWithBind);
    this._hudPauseButton.removeListener('RESUME_GAME', this.onResumeWithBind);
  }

  EHDI.GAME.updateManager.removeFrameListener(this.updateWithBind);
  // if (EHDI.BrowserInfo.isMobileDevice) {
  //   this.interactive = false;
  //   this.off('pointerdown', this.onTouchWithBind);
  // } else {
  //   window.removeEventListener('keydown', this.onKeyWithBind);
  // }

  this._animalActivatedWithBind = null;
  this._leafAnimationCompletedWithBind = null;
  this._tapAnimationCompletedWithBind = null;
  this._animapTappedWithBind = null;
  this._animapRemoveWarningWithBind = null;
  this._animapShowWarningWithBind = null;
};

EHDI.scene.GameScene.prototype.updateLevel = function () {
  if (this._level == 1 && this._currentTime <= 100) {
    this._animalSpawnDelay = 2000;
    this._snakeSpawnDelay = 2500;
    this._despawnDelay = 3000;
    this._level = 2;
  } else if (this._level == 2 && this._currentTime <= 80) {
    this._animalSpawnDelay = 1800;
    this._snakeSpawnDelay = 2000;
    this._despawnDelay = 2500;
    this._level = 3;
  } else if (this._level == 3 && this._currentTime <= 60) {
    this._animalSpawnDelay = 1500;
    this._snakeSpawnDelay = 1200;
    this._despawnDelay = 2100;
    this._level = 4;
  } else if (this._level == 4 && this._currentTime <= 40) {
    this._animalSpawnDelay = 1300;
    this._snakeSpawnDelay = 900;
    this._despawnDelay = 1700;
    this._level = 5;
  } else if (this._level == 5 && this._currentTime <= 20) {
    this._animalSpawnDelay = 900;
    this._snakeSpawnDelay = 600;
    this._despawnDelay = 1000;
    this._level = 6;
  }
};

EHDI.scene.GameScene.prototype.updateSpawnManager = function () {
  if (this._gameState == EHDI.GameStateEnum.GAMESTARTED) {
    if (this._idleSpawnData.length > 0 && this._snakeSpawnTimer.getTime() >= this._snakeCurrentSpawnDelay) {
      this.spawnAnimal(true);

      this._snakeCurrentSpawnDelay = this._snakeSpawnDelay * 0.5 + (this._snakeSpawnDelay * 0.5 * Math.random());

      this._snakeSpawnTimer.reset();
    }

    if (this._idleSpawnData.length > 0 && this._animalSpawnTimer.getTime() >= this._animalCurrentSpawnDelay) {
      this.spawnAnimal(false);

      this._animalCurrentSpawnDelay = this._animalSpawnDelay * 0.5 + (this._animalSpawnDelay * 0.5 * Math.random());

      this._animalSpawnTimer.reset();
    }
  }
};

EHDI.scene.GameScene.prototype.spawnAnimal = function (snake) {
  var index = Math.floor(Math.random() * this._idleSpawnData.length);
  var spawnData = this._idleSpawnData[index];

  this._idleSpawnData.splice(index, 1);
  this._activeSpawnData.push(spawnData);
  if (snake && this._despawnDelay == 4000)
    this.spawnGlow(spawnData.x, spawnData.y);

  var animal = EHDI.GetGlobalPool().animalPool.get();
  this._animals.push(animal);

  animal.init(spawnData, this._animalActivatedWithBind, snake, this._despawnDelay);
  animal.on('ANIMAL_TAPPED', this._animapTappedWithBind);
  animal.on('REMOVE_WARNING', this._animapRemoveWarningWithBind);
  animal.on('SHOW_WARNING', this._animapShowWarningWithBind);

  this._gameContainer.addChild(animal);

  this.spawnLeafAnimation(spawnData.x, spawnData.y);

  EHDI.GAME.soundManager.playSFX("animal_spawn");
}

EHDI.scene.GameScene.prototype.spawnGlow = function (xPos, yPos) {
  var glow = EHDI.GetGlobalPool().glowPool.get();

  glow.x = xPos;
  glow.y = yPos;
  glow.reset();

  this._glows.push(glow);

  this._hudContainer.addChild(glow);
}

EHDI.scene.GameScene.prototype.removeGlow = function (xPos, yPos) {
  var glow = null;

  for (var i = 0; i < this._glows.length; i++) {
    if (this._glows[i].x == xPos && this._glows[i].y == yPos) {
      glow = this._glows[i];
    }
  }

  if (glow != null) {
    var index = this._glows.indexOf(glow);

    if (index > -1)
      this._glows.splice(index, 1);

    this._hudContainer.removeChild(glow);
    EHDI.GetGlobalPool().glowPool.return(glow);
  }
}

EHDI.scene.GameScene.prototype.startGame = function () {
  this._gameTimer.reset();
  this._animalSpawnTimer.reset();
  this._snakeSpawnTimer.reset();
  this._scoreMultiplierTimer.reset();
  this.updateTime();

  this.gameStateManager(EHDI.GameStateEnum.GAMESTARTED);
};

EHDI.scene.GameScene.prototype.gameStateManager = function (newState) {
  if (this._gameState != newState) {
    this._gameState = newState;
  }
};

EHDI.scene.GameScene.prototype.spawnLeafAnimation = function (posX, posY) {
  var leafAnimation = EHDI.GetGlobalPool().leafPool.get();

  leafAnimation.init('fx_leaf');
  leafAnimation.getDisplay().x = posX;
  leafAnimation.getDisplay().y = posY + 70;

  this._leafAnimations.push(leafAnimation);

  this._foregroundContainer.addChild(leafAnimation.getDisplay());

  leafAnimation.addCompleteCallback(this._leafAnimationCompletedWithBind);
  leafAnimation.changeAnimation(false);
};

EHDI.scene.GameScene.prototype.spawnTapAnimation = function (posX, posY) {
  var tapAnimation = EHDI.GetGlobalPool().tapPool.get();

  tapAnimation.init('fx_hit');
  tapAnimation.getDisplay().x = posX;
  tapAnimation.getDisplay().y = posY;

  this._tapAnimations.push(tapAnimation);

  this._foregroundContainer.addChild(tapAnimation.getDisplay());

  tapAnimation.addCompleteCallback(this._tapAnimationCompletedWithBind);
  tapAnimation.changeAnimation(false, 'fx_tap_wrong');
};

EHDI.scene.GameScene.prototype.spawnWarning = function (posX, posY) {
  var warning = EHDI.GetGlobalPool().warningPool.get();

  warning.init(posX, posY);

  this._warnings.push(warning);

  this._hudContainer.addChild(warning);
};

EHDI.scene.GameScene.prototype.stopAllAnimals = function () {
  for (var i = 0; i < this._animals.length; i++) {
    this._animals[i].stop();
  }
};

EHDI.scene.GameScene.prototype.removeWarning = function (spawnX, spawnY) {
  for (var i = 0; i < this._warnings.length; i++) {
    if (this._warnings[i].spawnX == spawnX && this._warnings[i].spawnY == spawnY) {
      var warning = this._warnings[i];

      this._warnings.splice(i, 1);
      this._hudContainer.removeChild(warning);

      EHDI.GetGlobalPool().warningPool.return(warning);

      warning = null;

      break;
    }
  }
};

EHDI.scene.GameScene.prototype.showPostGamePopup = function () {
  if (this._gameState != EHDI.GameStateEnum.GAMEOVER) {
    this.gameStateManager(EHDI.GameStateEnum.GAMEOVER);

    this.stopAllAnimals();

    this._hudPauseButton.endGame();

    this._hudTimer.dispose();

    if ( !EHDI.GAME.constants.gameEndFunction ) {
		EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp
		  (this.getStar(this._scoreContainer.getScore()), this._scoreContainer.getScore()),
		  {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(),
		  EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
	}
	else EHDI.GAME.constants.gameEndFunction();
    /* var score = this._scoreContainer.getScore();
    if(score > EHDI.GAME.saveData.highScore) {
        EHDI.GAME.saveData.highScore = score;
        EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
            console.log("data saved.");
        });
    }
    EHDI.sbGame.end(score); */
  }
};

EHDI.scene.GameScene.prototype.pauseAllAnimals = function () {
  for (var i = 0; i < this._animals.length; i++) {
    this._animals[i].pause();
  }
};

EHDI.scene.GameScene.prototype.resumeAllAnimals = function () {
  for (var i = 0; i < this._animals.length; i++) {
    this._animals[i].resume();
  }
};

EHDI.scene.GameScene.prototype.getStar = function (score) {
  if (score >= 8000)
    return 3;
  else if (score >= 4000)
    return 2;
  else if (score >= 1500)
    return 1;
  else {
    return 0;
  }
}

EHDI.scene.GameScene.prototype.updateScore = function () {
  if (this._scoreMultiplierTimer.getTime() <= this._snakeSpawnDelay + 300) {
    if (this._scoreMultiplier < 5)
      this._scoreMultiplier++;
    else
      this._scoreMultiplier = 5;
  } else {
    this._scoreMultiplier = 1;
  }

  this._scoreContainer.addScore(this._score * this._scoreMultiplier);

  this._scoreMultiplierTimer.reset();
};

EHDI.scene.GameScene.prototype.update = function (delta) {
  this._deltaTotal += delta * 25;
  if (this._deltaTotal >= this._deltaLimit) {
    this._deltaMultiplier = Math.floor(this._deltaTotal / this._deltaLimit);

    for (var i = 0; i < this._deltaMultiplier; i++) {
      this.gameUpdate(this._deltaLimit);
    }

    this._deltaTotal -= (this._deltaMultiplier * this._deltaLimit);
  }
};

EHDI.scene.GameScene.prototype.gameUpdate = function (delta) {
  if (this._gameState  != EHDI.GameStateEnum.GAMEPAUSED) {
    dragonBones.WorldClock.clock.advanceTime(delta * 0.001);

    if (this._gameState  == EHDI.GameStateEnum.GAMESTARTED) {
      this.updateLevel();
      this.updateGlows();
      this.updateSpawnManager();
      this.updateAnimals();

      this.updateTime();
    }
  }
};

EHDI.scene.GameScene.prototype.updateGlows = function () {
  if (this._glows.length > 0) {
    for (var i = 0; i < this._glows.length; i++) {
      this._glows[i].update();
    }
  }
};

EHDI.scene.GameScene.prototype.updateAnimals = function () {
  if (this._animals.length > 0) {
    for (var i = 0; i < this._animals.length; i++) {
      this._animals[i].update();
    }
  }
};

EHDI.scene.GameScene.prototype.updateTime = function () {
  this._currentTime = this._totalTime - this._gameTimer.getTimeInSeconds();
  if (this._currentTime < 0)
    this._currentTime = 0;

  this._hudTimer.updateTime(this._currentTime);

  if (this._currentTime == 0)
    this.showPostGamePopup();
};

EHDI.scene.GameScene.prototype._handler_leafAnimationCompleted = function (leaf) {
  var index = this._leafAnimations.indexOf(leaf);

  if (index >= 0)
    this._leafAnimations.splice(index, 1);

  this._foregroundContainer.removeChild(leaf.getDisplay());

  EHDI.GetGlobalPool().leafPool.return(leaf);
};

EHDI.scene.GameScene.prototype._handler_tapAnimationCompleted = function (tap) {
  var index = this._tapAnimations.indexOf(tap);
  console.log('remove');
  if (index >= 0) {
    this._tapAnimations.splice(index, 1);
    console.log('1');
  }


  this._foregroundContainer.removeChild(tap.getDisplay());

  EHDI.GetGlobalPool().tapPool.return(tap);
};

EHDI.scene.GameScene.prototype._handler_animalActivated = function (animal, tapped) {
  if (this._gameState == EHDI.GameStateEnum.GAMESTARTED) {
    var animalsIndex = this._animals.indexOf(animal);

    animal.removeListener('ANIMAL_TAPPED', this._animapTappedWithBind);
    animal.removeListener('REMOVE_WARNING', this._animapRemoveWarningWithBind);
    animal.removeListener('SHOW_WARNING', this._animapShowWarningWithBind);

    if (animalsIndex >= 0)
      this._animals.splice(animalsIndex, 1);

    var index = this._activeSpawnData.indexOf(animal.getSpawnData());

    if (index >= 0)
      this._activeSpawnData.splice(index, 1);

    this._idleSpawnData.push(animal.getSpawnData());

    this._gameContainer.removeChild(animal);

    EHDI.GetGlobalPool().animalPool.return(animal);

    if ((tapped && !animal.isSnake()) || (!tapped && animal.isSnake()))
      this.showPostGamePopup();
  }
};

EHDI.scene.GameScene.prototype._handler_animalTapped = function (spawnX, spawnY, isSnake) {
  this.spawnTapAnimation(spawnX, spawnY);
  this.removeGlow(spawnX, spawnY)

  if(isSnake) {
    EHDI.GAME.soundManager.playSFX("select_serpent");
    this.updateScore();
  } else {
    EHDI.GAME.soundManager.playSFX("select_wrong_animal");
    this.stopAllAnimals();
  }
};

EHDI.scene.GameScene.prototype._handler_animalRemoveWarning = function (spawnX, spawnY, isSnake) {
  if (isSnake)
    this.removeWarning(spawnX, spawnY);
};

EHDI.scene.GameScene.prototype._handler_animalSpawnWarning = function (animal) {
  this.spawnWarning(animal.getSpawnData().x, animal.getSpawnData().y);
};

EHDI.scene.GameScene.prototype._handler_pauseGame = function (e) {
  this._gameTimer.pause(true);
  this._animalSpawnTimer.pause(true);
  this._snakeSpawnTimer.pause(true);
  this._scoreMultiplierTimer.pause(true);
  this.pauseAllAnimals();

  this._prevState = this._gameState;
  this.gameStateManager(EHDI.GameStateEnum.GAMEPAUSED);
};

EHDI.scene.GameScene.prototype._handler_resumeGame = function (e) {
  this._gameTimer.pause(false);
  this._animalSpawnTimer.pause(false);
  this._snakeSpawnTimer.pause(false);
  this._scoreMultiplierTimer.pause(false);
  this.resumeAllAnimals();

  this.gameStateManager(this._prevState);
};

EHDI.scene.GameScene.prototype.destroy = function () {
  this.gameStateManager(EHDI.GameStateEnum.GAMEOVER);
  this.destroyListeners();
  this.destroyGraphics();
  // EHDI.GetGlobalPool().gameScenePool.return(this);
};

EHDI.scene.GameScene.prototype.replay = function() {
  this.destroy();
  this.init();
  this.startGame();
}
